import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/main/main').then(m => m.MainComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'executive-summary',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./components/executive-summary/executive-summary').then(
                m => m.ExecutiveSummaryComponent
              ),
          },
          {
            // ?filter=beats|misses (anything else falls back to beats)
            path: 'beats',
            loadComponent: () =>
              import('./components/executive-summary/beats/beats').then(m => m.BeatsComponent),
          },
          {
            // ?filter=upgrades|downgrades (anything else falls back to upgrades)
            path: 'guidance',
            loadComponent: () =>
              import('./components/executive-summary/guidance/guidance').then(
                m => m.GuidanceComponent
              ),
          },
        ],
      },
      {
        // :companyName is the company slug id, e.g. `johnson_matthey`.
        path: 'company/:companyName',
        loadComponent: () =>
          import('./components/company-detail/company-detail').then(m => m.CompanyDetailComponent),
      },
      {
        path: 'peer-performance',
        loadComponent: () =>
          import('./components/peer-performance/peer-performance').then(
            m => m.PeerPerformanceComponent
          ),
      },
      {
        path: 'market-signals',
        loadComponent: () =>
          import('./components/market-signals/market-signals').then(m => m.MarketSignalsComponent),
      },
      {
        path: 'progress-tracker',
        loadComponent: () =>
          import('./components/progress-tracker/progress-tracker').then(
            m => m.ProgressTrackerComponent
          ),
      },
      {
        path: 'strategic-lens',
        loadComponent: () =>
          import('./components/strategic-lens/strategic-lens').then(m => m.StrategicLensComponent),
      },
      {
        path: 'admin-trust',
        loadComponent: () =>
          import('./components/admin-trust/admin-trust').then(m => m.AdminTrustComponent),
      },
      {
        path: 'charts-demo',
        loadComponent: () =>
          import('./components/charts-demo/charts-demo').then(m => m.ChartsDemoComponent),
      },
      { path: '', redirectTo: 'executive-summary', pathMatch: 'full' },
    ],
  },
  {
    path: 'error',
    loadComponent: () => import('./components/error/error').then(m => m.ErrorComponent),
  },
  { path: '**', redirectTo: 'executive-summary' },
];
